export enum ProjectPackagesList {
  ProjectPackagesForFrontend = 'Project Packages For Frontend',
  ProjectPackagesForBackend = 'Project Packages For Backend'
}
